<template>
  <v-card class="d-flex flex-column align-center justify-center pa-5">
    <v-card-title class="mb-5">Νέα περίοδος</v-card-title>
    <v-form class="form d-flex flex-column justify-center">
      <v-select
        v-model="year"
        :menu-props="{ auto: true }"
        label="Έτος"
        :items="['2020', '2021', '2022', '2023', '2024', '2025', '2026']"
        :error-messages="yearErrors"
        :disabled="true"
      ></v-select>

      <div class="d-flex justify-center">
        <v-btn
          class="success rounded text-sm-body-1 font-weight-regular mr-5"
          :loading="loader"
          @click="onSubmit"
        >
          <span>Προσθήκη</span>
        </v-btn>
        <v-btn
          class="secondary rounded text-sm-body-1 font-weight-regular"
          @click="$emit('closeDialog')"
        >
          <span>Επιστροφή</span>
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import { required } from "vuelidate/lib/validators";
export default {
  props: {
    year: String,
  },

  data() {
    return {
      todayDate: new Date(),
      loader: false,
    };
  },

  validations: {
    year: {
      required,
    },
  },

  computed: {
    yearErrors() {
      const errors = [];
      if (!this.$v.year.$dirty) return errors;
      if (!this.$v.year.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },
  },

  methods: {
    ...mapActions(["addPeriod"]),

    async onSubmit() {
      try {
        this.$v.$touch();
        if (this.$v.$invalid) return;
        this.loader = true;
        await axios.post(
          `${process.env.VUE_APP_BASE_URL}/Admin/AddMMFPeriods/${this.year}`
        );
        this.loader = false;

        this.$store.commit("toggleSnackbar", {
          open: true,
          color: "success",
          text: "Η προσθήκη περιόδου υποβολής ολοκληρώθηκε με επιτυχία!",
        });
        this.$emit("getPeriods");

        this.$emit("closeDialog");
      } catch (e) {}
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  width: 400px;
}
</style>